/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useCallback, useEffect, useState} from 'react';

// material
import SectionCard from '../../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from '../../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription';
import {Switch} from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './revenueMetrics_styles';

import {ENABLE_CPM_ENGAGEMENT_PRODUCT, ENABLE_CPM_AD_MGMT, ENABLE_INTERNAL_METRICS, ENABLE_AD_UNIT_UNDER_ENABLE_CPM_EGMT, ENABLE_AD_UNIT_UNDER_ENABLE_CPM_AD_MGMT} from "../consts";

/* ========== ~~~~~~~~~~ ADVANCED SETTINGS - SENTIMENT ~~~~~~~~~~ ========== */
const RevenueMetricsSettings = injectSheet(styles)((props) => {
    const { setSettings, settings } = props;

    const handleToggleUpdate = key => {
        let newValues = {
            ...settings
        };
        newValues[key] = !settings[key];
        return setSettings(newValues);
    };

    const handleDependentToggleUpdate = (parentkey,dependentkey) => {
        let newValues = {
            ...settings
        };
        newValues[parentkey] = !settings[parentkey]
        if(settings[parentkey])
        {
            if(settings[dependentkey])
            {
                newValues[dependentkey] = !settings[dependentkey]
            }
            else
            {
                newValues[dependentkey] = settings[dependentkey]
            }
        }
        else
        {
            newValues[dependentkey] = false
        }
        return setSettings(newValues);
    };

    return (
        <>
            <SectionCard klass={props.classes.revenueMetricsSettings}>
                <SectionGroup>
                    <SectionGroupDescription
                        title={'COOL Media Metrics'}
                    />
                </SectionGroup>
                <SectionGroup>
                    <Switch
                        variant={'primary'}
                        isStatic={false}
                        on={settings[ENABLE_INTERNAL_METRICS]}
                        handleClick={() => handleToggleUpdate(ENABLE_INTERNAL_METRICS)}
                    />
                    <SectionGroupDescription
                        title={'Show all internal metrics for the Monetization reports.'}
                    />
                </SectionGroup>
            </SectionCard>
            <SectionCard klass={props.classes.revenueMetricsSettings}>
                <SectionGroup>
                    <SectionGroupDescription
                        title={'Publisher Metrics'}
                    />
                </SectionGroup>
                <SectionGroup>
                    <Switch
                        variant={'primary'}
                        isStatic={false}
                        on={settings[ENABLE_CPM_ENGAGEMENT_PRODUCT]}
                        handleClick={() => handleDependentToggleUpdate(ENABLE_CPM_ENGAGEMENT_PRODUCT,ENABLE_AD_UNIT_UNDER_ENABLE_CPM_EGMT)}
                    />
                    <SectionGroupDescription
                        title={'Engagement Products'}
                        description={'Show CPM to publishers on Avg Page RPM report.'}
                    />
                </SectionGroup>
                {settings[ENABLE_CPM_ENGAGEMENT_PRODUCT] && <SectionGroup secondary>
                        <Switch
                            isStatic={!settings[ENABLE_CPM_ENGAGEMENT_PRODUCT]}
                            on={settings[ENABLE_AD_UNIT_UNDER_ENABLE_CPM_EGMT] && settings[ENABLE_CPM_ENGAGEMENT_PRODUCT]}
                            handleClick={() => handleToggleUpdate(ENABLE_AD_UNIT_UNDER_ENABLE_CPM_EGMT)}
                        />
                        <SectionGroupDescription
                            title={'Show Ad Unit in the CPM DropDown'}
                            description={'Show breakdown by Ad Unit to publishers under Avg Page CPM report on Enagagement Products Page.'}
                        />
                </SectionGroup>}
                <SectionGroup>
                    <Switch
                        variant={'primary'}
                        isStatic={false}
                        on={settings[ENABLE_CPM_AD_MGMT]}
                        handleClick={() => handleDependentToggleUpdate(ENABLE_CPM_AD_MGMT,ENABLE_AD_UNIT_UNDER_ENABLE_CPM_AD_MGMT)}
                    />
                    <SectionGroupDescription
                        title={'Display Ad Management'}
                        description={'Show CPM to publishers on Avg Page RPM report.'}
                    />
                </SectionGroup>
                {settings[ENABLE_CPM_AD_MGMT] && <SectionGroup secondary>
                        <Switch
                            isStatic={!settings[ENABLE_CPM_AD_MGMT]}
                            on={settings[ENABLE_AD_UNIT_UNDER_ENABLE_CPM_AD_MGMT] && settings[ENABLE_CPM_AD_MGMT]}
                            handleClick={() => handleToggleUpdate(ENABLE_AD_UNIT_UNDER_ENABLE_CPM_AD_MGMT)}
                        />
                        <SectionGroupDescription
                            title={'Show Ad Unit in the CPM DropDown'}
                            description={'Show breakdown by Ad Unit to publishers on Avg Page CPM report on Full Ad Management Page.'}
                        />
                </SectionGroup>}
            </SectionCard> 
        </>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default RevenueMetricsSettings;

